import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Logic moved to server-side (ExpenseReportsController#create)
  // This file remains for future dynamic enhancements (e.g. Turbo Streams handling animations)
}